import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"


import InputBank from '@/app/shared/components/inputs/InputBank.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'InputBankAccount',
  props: ['modelValue'],
  emits: ['update:modelValue'],
  setup(__props, { emit }) {

const props = __props;




function updateModel(value: any, field: string) {
    emit('update:modelValue', {
        ...props.modelValue,
        [field]: value,
    });
}

return (_ctx: any,_cache: any) => {
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_row = _resolveComponent("v-row")!

  return (_openBlock(), _createBlock(_component_v_row, null, {
    default: _withCtx(() => [
      _createVNode(_component_v_col, {
        cols: "12",
        md: "6"
      }, {
        default: _withCtx(() => [
          _createVNode(InputBank, {
            "model-value": __props.modelValue?.code_bank,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (updateModel($event, 'code_bank')))
          }, null, 8, ["model-value"])
        ]),
        _: 1
      }),
      _createVNode(_component_v_col, {
        cols: "12",
        md: "6"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_text_field, {
            "model-value": __props.modelValue?.agency,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (updateModel($event, 'agency'))),
            label: "Agência + dígito"
          }, null, 8, ["model-value"])
        ]),
        _: 1
      }),
      _createVNode(_component_v_col, {
        cols: "12",
        sm: "6",
        md: "6"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_text_field, {
            "model-value": __props.modelValue?.number,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (updateModel($event, 'number'))),
            label: "Conta + dígito"
          }, null, 8, ["model-value"])
        ]),
        _: 1
      }),
      _createVNode(_component_v_col, {
        cols: "12",
        sm: "6",
        md: "6"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_text_field, {
            "model-value": __props.modelValue?.pix_key,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (updateModel($event, 'pix_key'))),
            label: "Chave pix"
          }, null, 8, ["model-value"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})